import { Headers, Http, RequestOptions, Response } from '@angular/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { OauthService } from './oauth.service';
import { UrlService } from './url.service';
import { Rot13Service } from './rot13.service';
import { Md5 } from 'md5-typescript';
import { env } from '../../app.env';

@Injectable()
export class CommonHttpService {
    private authRequest = false;
    private bless = false;
    clientIp: string = '';

    private clientIpReady: Promise<void>;

    constructor(
        private http: Http,
        private oauthService: OauthService,
        private urlService: UrlService,
        private rot13: Rot13Service
    ) {
        this.clientIpReady = this.getClientIp().then(ip => {
            this.clientIp = ip;
        });
    }

    /**
     * This build RequestOptions object, applying Content-Type and
     * X-Requested-With headers.
     **/
    private buildOptions(body?): RequestOptions {
        
        const options = {
            headers: new Headers({
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
                'X-Client-IP': this.clientIp
            })
        };
        if (body !== undefined) {
            options.headers.append('body', body);
        }
        if (this.isAuthRequest()) {
            options.headers.append('Authorization', `Bearer ${this.loadToken()}`);
        }
        if (this.bless) {
            const jsonStr = JSON.stringify(body);
            const calculated = Md5.init(this.rot13.rotate(jsonStr)) + env.scarecrow_bless_key;
            const blessing = this.rot13.rotate(calculated);

            options.headers.append('Blessing', blessing);
        }

        return new RequestOptions(options);
    }

    /**
     * This call 'get' method from Http, building URL from current domain.
     **/
    public get(url): Observable<Response> {
        const request = this.http.get(
            this.urlService.build(url),
            this.buildOptions()
        );
        this.reset();

        return request;
    }

    /**
     * This call 'post' method from Http, building URL from current domain.
     **/
    public post(url: string, body?): Observable<Response> {
        const request = this.http.post(
            this.urlService.build(url),
            JSON.stringify(body),
            this.buildOptions(body)
        );
        this.reset();

        return request;
    }

    /**
     * This call 'put' method from Http, building URL from current domain.
     **/
    public put(url: string, body?): Observable<Response> {
        const request = this.http.put(
            this.urlService.build(url),
            JSON.stringify(body),
            this.buildOptions(body)
        );
        this.reset();

        return request;
    }

    /**
     * This call 'delete' method from Http, building URL from current domain.
     **/
    public delete(url: string): Observable<Response> {
        const request = this.http.delete(
            this.urlService.build(url),
            this.buildOptions()
        );
        this.reset();

        return request;
    }

    /**
     * authRequest property sets true.
     **/
    public useAuth() {
        this.authRequest = true;
        return this;
    }

    /**
     * bless property sets true.
     **/
    public mustBeBlessed() {
        this.bless = true;
        return this;
    }

    /**
     * authRequest property getter.
     **/
    public isAuthRequest(): boolean {
        return this.authRequest;
    }

    /**
     * Token property setter
     **/
    public loadToken(): string {
        return this.oauthService.getToken();
    }

    private reset() {
        this.authRequest = false;
        this.bless = false;
    }

    /**
     * 
     * @returns Get Client IP
     */

    private getClientIp(): Promise<string> {
        return fetch('https://engine.api.betalabs.net/api/me-ip')
            .then(response => response.json())
            .then(data => {
                if (data && data.ip) {
                    return data.ip;
                }
                return fetch('https://api.ipify.org?format=json')
                    .then(response => response.json())
                    .then(data => data.ip || '');
            })
            .catch(error => {
                console.warn('Falha ao obter IP do cliente Engine:', error);

                return fetch('https://api.ipify.org?format=json')
                    .then(response => response.json())
                    .then(data => data.ip || '')
                    .catch(() => '');
            });
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src727013012/src/src/app/shared/services/http.service.ts